import React from "react";
import { uniqBy } from "lodash";

/**
 * Copied from: This comes from: packages/ecom-common/src/lib/tile-utils.js
 * The intention is to prepare this component to be migrated to v3 and
 * this function was a dependency.
 * @param {*} str
 * @param {*} delimiter
 * @returns
 */
export const formatLineBreaks = (str, delimiter) => {
  const params = str?.split(delimiter) ?? [];
  if (!params.length) {
    return str;
  }
  return params.map((param, i) => (
    <React.Fragment key={i}>
      {param}
      {i !== params.length - 1 && <br />}
    </React.Fragment>
  ));
};

/**
 * Function to get the max number of a list formatted.
 * @param {*} prices
 * @returns
 */
export const getMaxPrice = (prices) => {
  const maxProductPrice = Math.max(...(prices || []));
  return maxProductPrice.toFixed(2);
};

/**
 * In case a given sku doesn't have list price
 * this function extracts the max list price from the
 * sku list.
 * @param {*} param0
 * @returns
 */
export const getListPrice = ({ selectedSKU, skus }) => {
  const price = selectedSKU?.listPrice || null;
  if (price) {
    return price;
  }
  const toListPrice = (sku) => Number(sku?.price?.listPrice);
  return getMaxPrice(skus?.map(toListPrice));
};

/**
 * In case the given sku doesn't have a sale price
 * this function extracts the max sale price from the sku list.
 * @param {*} param0
 * @returns
 */
export const getSalePrice = ({ selectedSKU, skus }) => {
  const isOnSale = selectedSKU?.price?.onSale || false;
  const price = selectedSKU?.price?.salePrice || null;
  if (!isOnSale) {
    return "";
  }
  if (price) {
    return price;
  }
  const toSalePrice = (sku) => Number(sku?.price?.salePrice);
  return getMaxPrice(skus?.map(toSalePrice));
};

/**
 * Checks if a given color has at least on sku available
 */
export const isColorAvailableAtAll = (c, skus) =>
  skus?.some(({ color, available }) => available && c?.code === color.code);

/**
 * Validates if for a given color and size combination there is at least
 * on sku available
 * @param {*} param0
 * @returns
 */
export const isColorAvailableForSelectedSize = ({
  color: c,
  selectedSize,
  skus,
}) =>
  skus?.some(
    ({ color, size, available }) =>
      available &&
      c?.code === color?.code &&
      (!selectedSize || selectedSize === size)
  );

/**
 * Validates if for a given size and color combination
 * there is at least one sku
 * @param {*} param0
 * @returns
 */
export const isSizeAvailableForSelectedColor = ({
  skus,
  size: s,
  selectedColor,
}) =>
  skus?.some(
    ({ color, size, available }) =>
      available &&
      s === size &&
      (!selectedColor?.code || selectedColor?.code === color.code)
  );

/**
 * Sorts the colors to match the pdp order.
 * @param {*} param0
 * @returns
 */
export const getSortedColors = ({ productCarousel, skus }) => {
  const colors = skus?.length
    ? uniqBy(
        skus?.map(({ color }) => color),
        "code"
      ).filter((c) => isColorAvailableAtAll(c, skus))
    : [];
  /*
   This is a hack to match the color swatch order to Product Display Page / Catalog
   In theory, colorDriver should be the source of truth / order but for the sake of
   UX this is a temporary fix.
   */
  const sortedColors = [];
  if (productCarousel?.length) {
    productCarousel.map(({ color }) => {
      const matchedColor = colors.find(
        (colorItem) => colorItem.code === color.code
      );
      if (matchedColor) {
        sortedColors.push(matchedColor);
      }
    });
  }

  return sortedColors;
};
